import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { Marker, Tooltip } from "react-leaflet";
import withFilters from '../../HOC/withFilters';
import t from "../../../languages/pl";

import L from 'leaflet';

import poi from "../../../images/mapPins/poiPin.png";

const iconPoi = new L.Icon({
    iconUrl: poi,
    iconRetinaUrl: poi,
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(45, 45),
});

const drawMarkers = (poiLocations, callback) => {
    if (!Array.isArray(poiLocations))
        poiLocations = [poiLocations];
    return poiLocations.map(marker => {
        if (!marker.punkt_gps)
            return false;
        return (
            <Marker
                key={marker.poi_id}
                icon={iconPoi}
                position={marker.punkt_gps}
                onClick={callback.bind(this, marker.poi_id)} >
                <Tooltip
                    direction="top"
                    className="toyotaFont"
                >
                    {t.type}: {marker.typ}
                    <br />
                    {t.name}: {marker.nazwa}
                    <br />
                    {t.address}: {marker.adres}
                </Tooltip>
            </Marker>
        );
    });
};

const PoiMarkers = ({poiLocations}) => {

    const handleMarkerClick = (id) => {
        console.log("poiLocations", poiLocations);
        console.log("id", id);
    };

    return (
        <Fragment>
            {drawMarkers( poiLocations, handleMarkerClick)}
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedCar: state.mapCarsReducer.selectedCar,
        poiLocations: state.settingsReducer.poiLocations,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
)(withFilters(PoiMarkers, true, true));

PoiMarkers.propTypes = {
    poiLocations: PropTypes.array,
    selectedCar: PropTypes.object,
    trackAllCars: PropTypes.func,
    setSelectedCar: PropTypes.func,
    resetToDefaults: PropTypes.func
};
